import $axios from '../services/apiLms.js'

const state = () => ({
    presences: {
        "H": 0,
        "S": 0,
        "I": 0,
        "A": 0,
        "others": 0
    },
    presences_detail: [],
})

const mutations = {
    ASSIGN_PRESENCES(state, payload) {
        state.presences = payload
    },
    ASSIGN_PRESENCES_DETAIL(state, payload) {
        state.presences_detail = payload
    },
}

const actions = {
    getPresences({ commit }, date) {
        return new Promise((resolve) => {
            $axios.get(`kepsek/presensi?date=${date}`)
                .then((response) => {
                    commit('ASSIGN_PRESENCES', response.data.data)
                    resolve(response.data)
                })
        })
    },
    getPresencesDetail({ commit }, params) {
        return new Promise((resolve) => {
            $axios.get(`kepsek/presensi/detail`, {
                params
            })
                .then((response) => {
                    commit('ASSIGN_PRESENCES_DETAIL', response.data.data)
                    resolve(response.data)
                })
        })
    },
    sendWhatsappReport({commit}, data) {
        return new Promise((resolve, reject) => {
            $axios.post(`kepsek/send-whatsapp-homeroom`, data).then(response => {
                resolve(response.data.data);
            }).catch(response => {
                reject(response.data.data);
            });
        });
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}